import axios, { AxiosRequestConfig } from 'axios';
import useSWR, { useSWRConfig } from 'swr';

export interface UseApi<Data, Error> {
  data: Data;
  error: Error;
  revalidate: () => void;
  isValidating: boolean;
  isLoading: boolean;
}

export const api = axios.create({
  baseURL: '/api',
});

const useApi = <D = any, E = any>(path: string, config?: AxiosRequestConfig): UseApi<D, E> => {
  const { mutate } = useSWRConfig();

  const { data, error, isValidating } = useSWR(
    path,
    async (url) => {
      const response = await api.get(url, config);
      return response.data;
    },
    {
      focusThrottleInterval: 20000,
    },
  );

  return {
    data,
    error,
    revalidate: () => {
      mutate(path);
    },
    isValidating,
    isLoading: !error && !data,
  };
};

export default useApi;
